import PageTitle from '../../Components/PageTitle';
import Navbar from '../../Components/Navbar';
import './styles.css'

export default function About() {
    return (
        <div className="App-background">
            <Navbar currentPage={"about"}></Navbar>
            <div className="page-shell">
            <PageTitle title="About"></PageTitle>
            </div>
        </div>
    );
}
